const list = {
  header: [
    {
      id: 'name.en',
      label: 'Name',
      orderBy: 'name.en',
      align: 'left',
    },
    {
      id: 'publish',
      label: 'Publish',
      align: 'left',
      switch: true,
    },
  ],
  permission: 'list',
  actions: ['bulk remove', 'delete', 'update'],
};
const create = {
  fields: [
    {
      type: 'mixed',
      name: 'name',
      label: 'Name',
      required: true,
      elements: [
        {
          type: 'text',
          name: 'en',
          label: 'English',
        },
        {
          type: 'text',
          name: 'ar',
          label: 'Arabic',
        },
      ],
    },
    {
      type: 'mixed',
      name: 'reports_to',
      label: 'Reports To',
      required: false,
      elements: [
        {
          type: 'text',
          name: 'en',
          label: 'English',
        },
        {
          type: 'text',
          name: 'ar',
          label: 'Arabic',
        },
      ],
    },
    {
      type: 'mixed',
      name: 'work_place',
      label: 'Work Place',
      required: false,
      elements: [
        {
          type: 'text',
          name: 'en',
          label: 'English',
        },
        {
          type: 'text',
          name: 'ar',
          label: 'Arabic',
        },
      ],
    },
    {
      type: 'mixed',
      name: 'role',
      label: 'Role',
      required: false,
      elements: [
        {
          type: 'text',
          name: 'en',
          label: 'English',
          rich: true,
        },
        {
          type: 'text',
          name: 'ar',
          label: 'Arabic',
          rich: true,
        },
      ],
    },
    {
      type: 'mixed',
      name: 'accountabilities',
      label: 'Accountabilities',
      required: false,
      elements: [
        {
          type: 'text',
          name: 'en',
          label: 'English',
          rich: true,
        },
        {
          type: 'text',
          name: 'ar',
          label: 'Arabic',
          rich: true,
        },
      ],
    },
    {
      type: 'mixed',
      name: 'qualifications',
      label: 'Qualifications',
      required: false,
      elements: [
        {
          type: 'text',
          name: 'en',
          label: 'English',
          rich: true,
        },
        {
          type: 'text',
          name: 'ar',
          label: 'Arabic',
          rich: true,
        },
      ],
    },
  ],
};
const edit = {
  fields: [
    {
      type: 'mixed',
      name: 'name',
      label: 'Name',
      required: true,
      elements: [
        {
          type: 'text',
          name: 'en',
          label: 'English',
        },
        {
          type: 'text',
          name: 'ar',
          label: 'Arabic',
        },
      ],
    },
    {
      type: 'mixed',
      name: 'reports_to',
      label: 'Reports To',
      required: false,
      elements: [
        {
          type: 'text',
          name: 'en',
          label: 'English',
        },
        {
          type: 'text',
          name: 'ar',
          label: 'Arabic',
        },
      ],
    },
    {
      type: 'mixed',
      name: 'work_place',
      label: 'Work Place',
      required: false,
      elements: [
        {
          type: 'text',
          name: 'en',
          label: 'English',
        },
        {
          type: 'text',
          name: 'ar',
          label: 'Arabic',
        },
      ],
    },
    {
      type: 'mixed',
      name: 'role',
      label: 'Role',
      required: false,
      elements: [
        {
          type: 'text',
          name: 'en',
          label: 'English',
          rich: true,
        },
        {
          type: 'text',
          name: 'ar',
          label: 'Arabic',
          rich: true,
        },
      ],
    },
    {
      type: 'mixed',
      name: 'accountabilities',
      label: 'Accountabilities',
      required: false,
      elements: [
        {
          type: 'text',
          name: 'en',
          label: 'English',
          rich: true,
        },
        {
          type: 'text',
          name: 'ar',
          label: 'Arabic',
          rich: true,
        },
      ],
    },
    {
      type: 'mixed',
      name: 'qualifications',
      label: 'Qualifications',
      required: false,
      elements: [
        {
          type: 'text',
          name: 'en',
          label: 'English',
          rich: true,
        },
        {
          type: 'text',
          name: 'ar',
          label: 'Arabic',
          rich: true,
        },
      ],
    },
  ],
};

const order = {
  fields: [
    {
      id: 'name',
      label: 'Name',
      child: 'en',
      align: 'left',
    },
  ],
  permission: 'order',
};

const search = {
  fields: [
    {
      type: 'text',
      name: 'name',
    },
  ],
};

const data = { list, create, edit, order, search };

export default data;
